import React from "react";
import "./HTML_MAIN_CSS.css";

const HTMLClasses = () => {
  return (
    <div className="html-container">
      <h1>HTML – Classes</h1>

      {/* 1. Introduction */}
      <section id="introduction">
        <h2>1. Introduction</h2>
        <p>
          In HTML, a <code>class</code> is an attribute used to assign one or more names to an element. 
          Classes are primarily used for styling elements with CSS and targeting them with JavaScript.
        </p>
      </section>

      {/* 2. Syntax */}
      <section id="syntax">
        <h2>2. Syntax</h2>
        <pre>
          <code>{`<element class="className1 className2">Content</element>`}</code>
        </pre>
        <p>You can assign multiple classes by separating them with a space.</p>
      </section>

      {/* 3. Applying CSS with Classes */}
      <section id="css-classes">
        <h2>3. Applying CSS with Classes</h2>
        <p>Example of using classes for styling:</p>
        <pre>
          <code>{`<style>
.container {
  background-color: #f0f0f0;
  padding: 20px;
  border-radius: 8px;
}

.highlight {
  color: #007bff;
  font-weight: bold;
}
</style>

<div class="container">
  <p class="highlight">This paragraph is highlighted using a class.</p>
</div>`}</code>
        </pre>
      </section>

      {/* 4. Multiple Classes */}
      <section id="multiple-classes">
        <h2>4. Multiple Classes</h2>
        <p>Assigning multiple classes to a single element:</p>
        <pre>
          <code>{`<p class="highlight large-text">This text has multiple classes applied.</p>`}</code>
        </pre>
        <p>CSS Example:</p>
        <pre>
          <code>{`.large-text { font-size: 1.5rem; }`}</code>
        </pre>
      </section>

      {/* 5. Targeting Classes with JavaScript */}
      <section id="javascript-classes">
        <h2>5. Targeting Classes with JavaScript</h2>
        <p>You can select elements by class name using JavaScript:</p>
        <pre>
          <code>{`<script>
const elements = document.getElementsByClassName('highlight');
for (let el of elements) {
  el.style.color = 'red';
}
</script>`}</code>
        </pre>
      </section>

      {/* 6. Best Practices */}
      <section id="best-practices">
        <h2>6. Best Practices</h2>
        <ul>
          <li>Use descriptive class names that reflect purpose or role.</li>
          <li>Follow a naming convention like BEM (<code>block__element--modifier</code>).</li>
          <li>Use classes instead of IDs when multiple elements share the same style.</li>
          <li>Keep class names readable, lowercase, and hyphen-separated.</li>
        </ul>
      </section>

      {/* 7. Summary */}
      <section id="summary">
        <h2>7. Summary</h2>
        <ul>
          <li>The <code>class</code> attribute assigns one or more names to HTML elements.</li>
          <li>Classes are used for CSS styling and JavaScript targeting.</li>
          <li>Multiple classes can be assigned by separating names with spaces.</li>
          <li>Use descriptive, consistent class names for maintainable code.</li>
        </ul>
      </section>
    </div>
  );
};

export default HTMLClasses;
